import { useCallback, useContext, useRef } from "react";

import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import {
  deleteClienteProposta,
  updateClienteProposta,
} from "../../../../repositories/qerpapi/erp/faturamento/ClientePropostaRepository";
import { notify } from "../../../../utils/notify";
import { TriagemContratoContext } from "../contexts/TriagemContratoContext";
import { validNotNull } from "../../../../utils/validations";
import { createContrato } from "../../../../repositories/qerpapi/erp/faturamento/ContratoRepository";
import { formatDate } from "../../../../utils/formatDate";
import { findFormasPagtos } from "../../../../repositories/qerpapi/erp/prouser/v1/FormasPagtosRepository";
import { findIndexes } from "../../../../repositories/qerpapi/erp/financeiro/IndicesRepository";
import { findTipoPagamento } from "../../../../repositories/qerpapi/erp/prouser/v1/TipoPagamento";
import { indexTypeContractByCompany } from "../../../../repositories/qerpapi/erp/faturamento/TipoContratosRepository";
import { findAgencia } from "../../../../repositories/qerpapi/erp/financeiro/AgenciasRepository";
import { findContratoServico } from "../../../../repositories/qerpapi/erp/faturamento/ContratoServicoRepository";
import { getBillingRules } from "../../../../repositories/qerpapi/v3/faturamento/ContratoRepository";
import Swal from "sweetalert2";
import { GlobalVariables } from "../../../../GlobalVariables";
import MaskService from "../../../../utils/mask/maskService";
import {
  index as indexLeadOrigin,
  store as storeLeadOrigin,
  update as updateLeadOrigin,
} from "../../../../repositories/qerpapi/v3/faturamento/OrigemLeadRepository";
import {
  index as indexSaleType,
  store as storeSaleType,
  update as updateSaleType,
} from "../../../../repositories/qerpapi/v3/faturamento/TipoVendaRepository";

const useTriagemContratoController = () => {
  const billingRulerFetchedRef = useRef(false);

  const {
    customerProposals,
    setCustomerProposals,

    singleServiceType,
    singleRegimeCompetence,
    singleCompetenceDate,
    singleBank,
    singlePaymentType,
    singlePaymentWay,
    singleSlipType,
    singleNfse,
    singleBillingRuler,
    setSingleBillingRuler,
    setSingleFirstInstallment,
    setSingleServiceType,
    setSingleRegimeCompetence,
    setSingleCompetenceDate,
    setSingleBank,
    setSinglePaymentType,
    setSinglePaymentWay,
    setSingleSlipType,
    setSingleNfse,
    singleFirstInstallment,

    setRecurrentServiceType,
    setRecurrentFirstMonthlyDate,
    setRecurrentExpirationDay,
    setRecurrentReadjustment,
    setRecurrentRegimeCompetence,
    setRecurrentCompetenceDate,
    setRecurrentValidityDate,
    setRecurrentBank,
    setRecurrentPaymentType,
    setRecurrentFrequency,
    setRecurrentSlipType,
    setRecurrentNfse,
    recurrentServiceType,
    recurrentFirstMonthlyDate,
    recurrentExpirationDay,
    recurrentReadjustment,
    recurrentRegimeCompetence,
    recurrentCompetenceDate,
    recurrentValidityDate,
    recurrentBank,
    recurrentPaymentType,
    recurrentFrequency,
    recurrentSlipType,
    recurrentNfse,
    recurrentBillingRuler,
    setRecurrentBillingRuler,

    proposalCode,
    setProposalCode,
    revisionDate,
    setRevisionDate,
    rowEdit,
    setRowEdit,
    setErrors,
    variablesModule,
    setLoading,
    setLoadingsInputs,
    setPaymentWayList,
    paymentWayList,
    billingRulerList,
    setBillingRulerList,
    readjustmentList,
    setReadjustmentList,
    paymentTypeList,
    setPaymentTypeList,
    contractTypeList,
    setContractTypeList,
    bankList,
    setBankList,
    serviceList,
    setServiceList,
    setOriginProposal,
    generatedInstallments,
    setGeneratedInstallments,
    financialResponsibleEnabled,
    financialResponsibleInfos,
    leadOrigin,
    setLeadOrigin,
    listLeadOrigin,
    setListLeadOrigin,
    saleType,
    setSaleType,
    listSaleType,
    setListSaleType,
    salesmanInfos,
    setSalesmanInfos,
  } = useContext(TriagemContratoContext);
  const { queryParams } = useContext(QueryParamsContext);

  const returnCompetencyAndVigency = useCallback(
    (context) => {
      const optionsStates = {
        single: {
          regimeCompetence: singleRegimeCompetence,
        },
        recurrent: {
          regimeCompetence: recurrentRegimeCompetence,
        },
      };

      const { regimeCompetence } = optionsStates[context];

      if (!regimeCompetence) return null;

      const date = formatDate({
        date: new Date(),
        separator: "-",
        format: "yyyy-mm-dd",
      });

      const yearFromDeadline = date.split("-")[0],
        monthByDeadline = date.split("-")[1];

      const currentCompetency = () => ({
        competenceDate: `${monthByDeadline}/${yearFromDeadline}`,
        validityDate: `${monthByDeadline}/${parseInt(yearFromDeadline) + 1}`,
      });

      const previousCompetency = () => {
        const newYearFromDeadline =
            parseInt(monthByDeadline) - 1 === 0
              ? parseInt(yearFromDeadline) - 1
              : parseInt(yearFromDeadline),
          newMonthFromDeadline = (
            parseInt(monthByDeadline) - 1 === 0
              ? 12
              : parseInt(monthByDeadline) - 1
          )
            .toString()
            .padStart(2, "0");

        return {
          competenceDate: `${newMonthFromDeadline}/${newYearFromDeadline}`,
          validityDate: `${newMonthFromDeadline}/${newYearFromDeadline + 1}`,
        };
      };

      const nextCompetency = () => {
        const newYearFromDeadline =
            parseInt(monthByDeadline) + 1 === 13
              ? parseInt(yearFromDeadline) + 1
              : parseInt(yearFromDeadline),
          newMonthFromDeadline = (
            parseInt(monthByDeadline) + 1 === 13
              ? 1
              : parseInt(monthByDeadline) + 1
          )
            .toString()
            .padStart(2, "0");

        return {
          competenceDate: `${newMonthFromDeadline}/${newYearFromDeadline}`,
          validityDate: `${newMonthFromDeadline}/${newYearFromDeadline + 1}`,
        };
      };

      const competencies = (index) =>
        ({
          atual: currentCompetency,
          anterior: previousCompetency,
          posterior: nextCompetency,
        }[index]());

      return competencies(regimeCompetence.value);
    },
    [recurrentRegimeCompetence, singleRegimeCompetence]
  );

  const handleScheduling = async () => {
    try {
      if (!revisionDate) {
        setErrors({ revisionDate: "Selecione uma data" });
        return;
      }

      setLoading(true);

      const response = await updateClienteProposta({
        empresa_cnpj: queryParams.empresa_cnpj,
        id: rowEdit.id,
        body: {
          cliente_proposta: {
            revisao_data: revisionDate,
          },
        },
      });

      if (response?.success) {
        notify("Data de revisão salva com sucesso.", true, "success");

        const copy = [...customerProposals];
        const indexEdit = copy.findIndex((i) => i.id === rowEdit.id);
        copy[indexEdit].revisao_data = revisionDate;
        setCustomerProposals(copy);
        setRowEdit({});
        return;
      }

      notify("Não foi possível salvar a data de revisão.");
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleClearContext = () => {
    setSingleFirstInstallment("");
    setSingleServiceType(null);
    setSingleRegimeCompetence(null);
    setSingleCompetenceDate("mm/aaaa");
    setSinglePaymentType(null);
    setSinglePaymentWay(null);
    setSingleSlipType(null);
    setSingleNfse(true);
    setSingleBillingRuler(null);
    setRecurrentServiceType(null);
    setRecurrentFirstMonthlyDate(
      formatDate({ date: new Date(), separator: "-", format: "yyyy-mm-dd" })
    );
    setRecurrentExpirationDay("");
    setRecurrentReadjustment(null);
    setRecurrentRegimeCompetence(null);
    setRecurrentCompetenceDate("mm/aaaa");
    setRecurrentValidityDate("mm/aaaa");
    setRecurrentPaymentType(null);
    setRecurrentFrequency(null);
    setRecurrentSlipType(null);
    setRecurrentNfse(true);
    setRecurrentBillingRuler(null);
    setErrors({});
    setRevisionDate("");
    setProposalCode("");
    setOriginProposal("");
    setLeadOrigin(null);
    setSaleType(null);
    setSalesmanInfos(null);
    setGeneratedInstallments([]);
  };

  const isCardPayment = (paymentType) => {
    const desc = (paymentType?.descricao || "").toLowerCase();
    return desc.includes("cartao") || desc.includes("cartão");
  };

  const handleSubmit = async (proposalCrm) => {
    try {
      if (
        ![GlobalVariables.DefaultCompanyId, 25].includes(
          parseInt(queryParams?.empresa_id)
        )
      )
        return notify(
          "Não é possível aprovar triagem de contrato em empresas diferentes da principal. Refaça o login para aprovar!"
        );

      if (!proposalCrm?.proposta_crm_id)
        return console.debug("Não há código de proposta.");

      setLoading(true);

      let requireds = [];

      const hasSingle = (proposalCrm?.proposal_products || []).find(
        (p) => p.integration_details?.tiposervico === "A"
      );
      const hasRecurrent = (proposalCrm?.proposal_products || []).find(
        (p) => p.integration_details?.tiposervico === "R"
      );

      if (hasSingle) {
        requireds = [
          { value: singleServiceType, key: "singleServiceType" },
          { value: singleRegimeCompetence, key: "singleRegimeCompetence" },
          { value: singleBank, key: "singleBank" },
          { value: singlePaymentType, key: "singlePaymentType" },
          { value: singlePaymentWay, key: "singlePaymentWay" },
          { value: singleCompetenceDate, key: "singleCompetenceDate" },
        ];

        if (
          singlePaymentType?.id ===
          variablesModule.ERP_QYON.TIPO_PAGAMENTO_BOLETO_ID
        ) {
          requireds.push({ value: singleSlipType, key: "singleSlipType" });
        }

        if (!isCardPayment(singlePaymentType)) {
          requireds.push({
            value: singleBillingRuler,
            key: "singleBillingRuler",
          });
        }
      }

      if (hasRecurrent) {
        requireds = [
          ...requireds,
          { value: recurrentServiceType, key: "recurrentServiceType" },
          { value: recurrentExpirationDay, key: "recurrentExpirationDay" },
          { value: recurrentReadjustment, key: "recurrentReadjustment" },
          {
            value: recurrentRegimeCompetence,
            key: "recurrentRegimeCompetence",
          },
          { value: recurrentBank, key: "recurrentBank" },
          { value: recurrentPaymentType, key: "recurrentPaymentType" },
          { value: recurrentFrequency, key: "recurrentFrequency" },
          { value: recurrentCompetenceDate, key: "recurrentCompetenceDate" },
          { value: recurrentValidityDate, key: "recurrentValidityDate" },
        ];

        if (
          recurrentPaymentType?.id ===
          variablesModule.ERP_QYON.TIPO_PAGAMENTO_BOLETO_ID
        ) {
          requireds.push({
            value: recurrentSlipType,
            key: "recurrentSlipType",
          });
        }

        if (!isCardPayment(recurrentPaymentType)) {
          requireds.push({
            value: recurrentBillingRuler,
            key: "recurrentBillingRuler",
          });
        }
      }

      const respValidation = validNotNull(requireds);

      let totalSingle = 0;
      let totalRecurrent = 0;
      let hasServiceWithoutIntegration = false;

      (proposalCrm?.proposal_products || []).forEach((item) => {
        const value = parseFloat(item?.total_value_with_discount || 0);

        if (item.integration_details?.tiposervico === "A") totalSingle += value;

        if (item.integration_details?.tiposervico === "R")
          totalRecurrent += value;

        if (!item?.integration_code) hasServiceWithoutIntegration = true;
      });

      if (hasRecurrent) {
        if (typeof totalRecurrent !== "number") {
          respValidation.error = true;
          notify("Não foi possível calcular o total dos itens recorrentes");
        }

        if (
          recurrentValidityDate === "mm/aaaa" ||
          recurrentValidityDate.length !== 7
        ) {
          respValidation.error = true;
          respValidation.errorsValidation.recurrentValidityDate =
            "Vigência inválida";
        }

        if (
          recurrentCompetenceDate === "mm/aaaa" ||
          recurrentCompetenceDate.length !== 7
        ) {
          respValidation.error = true;
          respValidation.errorsValidation.recurrentCompetenceDate =
            "Competência inválida";
        }
      }

      if (hasSingle) {
        if (typeof totalSingle !== "number") {
          respValidation.error = true;
          notify("Não foi possível calcular o total dos itens avulsos");
        }

        if (
          singleCompetenceDate === "mm/aaaa" ||
          singleCompetenceDate.length !== 7
        ) {
          respValidation.error = true;
          respValidation.errorsValidation.singleCompetenceDate =
            "Competência inválida";
        }
      }

      if (hasServiceWithoutIntegration) {
        respValidation.error = true;
        notify(
          "Existem serviços nesta proposta que não foram integrados com o ERP."
        );
      }

      setErrors(respValidation.errorsValidation);

      let notExpirationsValid = (generatedInstallments || []).find(
        (installment) =>
          !installment.data_venda ||
          !MaskService.removeMaskDecimal(installment.valor_unitario)
      );

      if (notExpirationsValid) {
        respValidation.error = true;
        notify("Exitem parcelas com dados incompletos.");
        return;
      }

      const sumAvulso = (proposalCrm?.proposal_products || []).reduce(
        (acc, item) => {
          if (item?.integration_details?.tiposervico === "A") {
            return parseFloat(
              (acc + parseFloat(item?.total_value_with_discount || 0)).toFixed(
                2
              )
            );
          }
          return acc + 0;
        },
        0
      );

      const sumInstalments = (generatedInstallments || []).reduce(
        (acc, item) => {
          return parseFloat(
            (
              acc + (MaskService.removeMaskDecimal(item.valor_unitario) || 0)
            ).toFixed(2)
          );
        },
        0
      );

      if (generatedInstallments?.length && sumAvulso !== sumInstalments) {
        notify(
          "A soma dos valores dos itens avulsos é diferente da soma dos valores das parcelas."
        );
        return;
      }

      if (respValidation.error)
        return notify("Preencha os campos obrigatórios.");

      const itemsContractsA = [];
      const itemsContractsR = [];
      (proposalCrm?.proposal_products || []).forEach((p) => {
        const product = {
          idservico: p.integration_code,
          quantidade: p.quantity,
          valorunitario: (
            parseFloat(p.total_value_with_discount) / parseFloat(p.quantity)
          ).toFixed(2),
          valortotal: parseFloat(p.total_value_with_discount).toFixed(2),
        };

        if (p.integration_details?.tiposervico === "A")
          itemsContractsA.push(product);
        else if (p.integration_details?.tiposervico === "R")
          itemsContractsR.push(product);
      });

      const currentDate = new Date();

      const body = {
        contratos: [],
      };

      if (hasRecurrent && totalRecurrent) {
        const isBankSlip = recurrentPaymentType.descricao
          .toLowerCase()
          .includes("boleto")
          ? 1
          : 0;

        const bodyRecurrent = {
          idempresa: queryParams?.empresa_id || 6,
          idusuario: queryParams?.usuario_id || 70,
          idcliente: rowEdit?.cliente?.id,
          modalidade: "R",
          idtipocontrato: recurrentServiceType.id,
          reajusteperiod: recurrentFrequency.value,
          total: totalRecurrent,
          idtipopagamento: recurrentPaymentType.id,
          formarecebimento: recurrentPaymentType.descricao,
          vigencia_renovacao: recurrentValidityDate,
          dia_vencimento: recurrentExpirationDay,
          idtiporeajuste: recurrentReadjustment.id,
          tipoboleto:
            recurrentPaymentType?.id ===
            variablesModule.ERP_QYON.TIPO_PAGAMENTO_BOLETO_ID
              ? recurrentSlipType.value
              : null,
          status: "A",
          regime_competencia: recurrentRegimeCompetence.value,
          idagencia: recurrentBank.id,
          id_modelo_contrato: 1,
          dataemissao: currentDate,
          origem: "CRM",
          datavencimento1: recurrentFirstMonthlyDate,

          contratoitens: itemsContractsR,

          proposta: proposalCode,
          proposta_crm_id: rowEdit.proposta_crm_id,

          flag_gerar_boleto: isBankSlip,
          flag_email_boleto: isBankSlip,

          flag_emitir_nfse: recurrentNfse ? 1 : 0,
          flag_enviar_email: 1,
          flag_email_nfse: recurrentNfse ? 1 : 0,

          tipo_aprovacao_id: 1,
          origem_lead_id: leadOrigin?.id || null,
          tipo_venda_id: saleType?.id || null,
          id_vendedor: salesmanInfos?.id || null,
          cliente_responsavel_financeiro_id: financialResponsibleEnabled
            ? financialResponsibleInfos?.id || null
            : null,
          flag_gerar_demonstrativo_financeiro: 1,
          flag_email_demonstrativo_financeiro: 1,
          regua_cobranca_id: recurrentBillingRuler?.value || null,
        };

        body.contratos.push(bodyRecurrent);
      }

      if (hasSingle && totalSingle) {
        const isBankSlip = singlePaymentType.descricao
          .toLowerCase()
          .includes("boleto")
          ? 1
          : 0;

        const bodySingle = {
          idempresa: queryParams?.empresa_id || 6,
          idusuario: queryParams?.usuario_id || 70,
          idcliente: rowEdit?.cliente?.id,
          modalidade: "A",
          idtipocontrato: singleServiceType.id,
          total: totalSingle,
          idtipopagamento: singlePaymentType.id,
          formarecebimento: singlePaymentType.descricao,
          idformapagamento: singlePaymentWay.id,
          tipoboleto:
            singlePaymentType?.id ===
            variablesModule.ERP_QYON.TIPO_PAGAMENTO_BOLETO_ID
              ? singleSlipType.value
              : null,
          status: "A",
          regime_competencia: singleRegimeCompetence.value,
          idagencia: singleBank.id,
          id_modelo_contrato: 1,
          dataemissao: currentDate,
          origem: "CRM",
          datavencimento1: singleFirstInstallment,

          flag_gerar_boleto: isBankSlip,
          flag_email_boleto: isBankSlip,

          flag_emitir_nfse: singleNfse ? 1 : 0,
          flag_enviar_email: 1,
          flag_email_nfse: singleNfse ? 1 : 0,
          regua_cobranca_id: singleBillingRuler?.value || null,

          contratoitens: itemsContractsA,

          proposta: proposalCode,
          proposta_crm_id: rowEdit.proposta_crm_id,

          parcelas: (generatedInstallments || []).map((p) => ({
            valor: MaskService.removeMaskDecimal(p.valor_unitario),
            vencimento: p.data_venda,
          })),

          tipo_aprovacao_id: 1,
          origem_lead_id: leadOrigin?.id || null,
          tipo_venda_id: saleType?.id || null,
          id_vendedor: salesmanInfos?.id || null,
          cliente_responsavel_financeiro_id: financialResponsibleEnabled
            ? financialResponsibleInfos?.id || null
            : null,
          flag_gerar_demonstrativo_financeiro: 1,
          flag_email_demonstrativo_financeiro: 1,
        };

        body.contratos.push(bodySingle);
      }

      if (!body.contratos.length) {
        return notify(
          "Não foi possível construir o contrato com os dados obtidos."
        );
      }

      const response = await createContrato({
        empresa_cnpj: queryParams.empresa_cnpj,
        body,
      });

      if (response?.success) {
        await updateClienteProposta({
          id: rowEdit.id,
          body: { cliente_proposta: { aprovado: 1 } },
          empresa_cnpj: queryParams.empresa_cnpj,
        });

        notify("Contrato aprovado com sucesso.", true, "success");

        if (!totalRecurrent) {
          notify(
            "No contrato recorrente não havia valor, portanto foi ignorado.",
            true,
            "warning"
          );
        }

        if (!totalSingle) {
          notify(
            "No contrato avulso não havia valor, portanto foi ignorado.",
            true,
            "warning"
          );
        }

        setCustomerProposals((current) =>
          current.filter((i) => i.id !== rowEdit.id)
        );
        setRowEdit({});

        handleClearContext();

        return;
      }

      notify("Não foi possível aprovar este contrato.");
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getPaymentWay = useCallback(
    async (proposalCrm) => {
      try {
        setLoadingsInputs((current) => ({
          ...current,
          paymentWayList: true,
        }));

        const response = paymentWayList.length
          ? {
              success: true,
              data: paymentWayList,
            }
          : await findFormasPagtos(queryParams.empresa_cnpj);

        if (response.success && Array.isArray(response.data)) {
          setPaymentWayList(response.data);

          let payment = null;

          payment = response.data.find(
            (i) => i.id === variablesModule.ERP_QYON.TIPO_PAGAMENTO_1X_ID
          );

          if (!payment) return;

          setSinglePaymentWay(payment);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingsInputs((current) => ({
          ...current,
          paymentWayList: false,
        }));
      }
    },
    [
      paymentWayList,
      queryParams.empresa_cnpj,
      setLoadingsInputs,
      setPaymentWayList,
      setSinglePaymentWay,
      variablesModule.ERP_QYON.TIPO_PAGAMENTO_1X_ID,
    ]
  );

  const getReadjustment = useCallback(async () => {
    try {
      setLoadingsInputs((current) => ({
        ...current,
        readjustmentList: true,
      }));

      const response = readjustmentList.length
        ? {
            success: true,
            data: readjustmentList,
          }
        : await findIndexes(queryParams.empresa_cnpj);

      if (response.success && Array.isArray(response.data)) {
        setReadjustmentList(response.data);

        const igpm = response.data.find(
          (b) => b.id === variablesModule.ERP_QYON.TIPO_REAJUSTE_IGMPAC12_ID
        );

        if (!igpm) return;

        setRecurrentReadjustment(igpm);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingsInputs((current) => ({
        ...current,
        readjustmentList: false,
      }));
    }
  }, [
    queryParams.empresa_cnpj,
    readjustmentList,
    setLoadingsInputs,
    setReadjustmentList,
    setRecurrentReadjustment,
    variablesModule.ERP_QYON.TIPO_REAJUSTE_IGMPAC12_ID,
  ]);

  const getPaymentType = useCallback(async () => {
    try {
      setLoadingsInputs((current) => ({ ...current, paymentTypeList: true }));

      const response = paymentTypeList.length
        ? {
            success: true,
            data: paymentTypeList,
          }
        : await findTipoPagamento(queryParams.empresa_cnpj);

      if (response.success && Array.isArray(response.data)) {
        setPaymentTypeList(response.data);

        const paymentSlip = response.data.find(
          (b) => b.id === variablesModule.ERP_QYON.TIPO_PAGAMENTO_BOLETO_ID
        );

        if (!paymentSlip) return;

        setSinglePaymentType(paymentSlip);
        setRecurrentPaymentType(paymentSlip);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingsInputs((current) => ({
        ...current,
        paymentTypeList: false,
      }));
    }
  }, [
    paymentTypeList,
    queryParams.empresa_cnpj,
    setLoadingsInputs,
    setPaymentTypeList,
    setRecurrentPaymentType,
    setSinglePaymentType,
    variablesModule.ERP_QYON.TIPO_PAGAMENTO_BOLETO_ID,
  ]);

  const getContractType = useCallback(
    async () => {
      try {
        if (
          contractTypeList.length ||
          !queryParams?.empresa_cnpj ||
          !queryParams?.empresa_id
        )
          return;

        setLoadingsInputs((current) => ({
          ...current,
          contractTypeList: true,
        }));

        const response = contractTypeList.length
          ? {
              success: true,
              data: contractTypeList,
            }
          : await indexTypeContractByCompany({
              empresa_cnpj: queryParams?.empresa_cnpj,
              empresa_id: queryParams?.empresa_id,
              where: { ativo: "S" },
            });

        if (response.success && Array.isArray(response.data)) {
          setContractTypeList(response.data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingsInputs((current) => ({
          ...current,
          contractTypeList: false,
        }));
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      queryParams?.empresa_cnpj,
      setLoadingsInputs,
      setContractTypeList,
      queryParams?.empresa_id,
    ]
  );

  const getBank = useCallback(async () => {
    try {
      if (bankList.length) return;

      setLoadingsInputs((current) => ({ ...current, bankList: true }));

      const response = bankList.length
        ? {
            success: true,
            data: bankList,
          }
        : await findAgencia(queryParams.empresa_cnpj, queryParams.usuario_id);

      if (response.success && Array.isArray(response.data)) {
        setBankList(response.data);

        const defaultBank = response.data.find((b) => b.id === 51);

        if (!defaultBank) return;

        setSingleBank(defaultBank);
        setRecurrentBank(defaultBank);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingsInputs((current) => ({ ...current, bankList: false }));
    }
  }, [bankList, queryParams.empresa_cnpj, queryParams.usuario_id, setBankList, setLoadingsInputs, setRecurrentBank, setSingleBank]);

  const getService = useCallback(async () => {
    try {
      if (serviceList.length) return;

      setLoadingsInputs((current) => ({
        ...current,
        serviceList: true,
      }));

      const response = serviceList.length
        ? {
            success: true,
            data: serviceList,
          }
        : await findContratoServico({
            empresa_cnpj: queryParams.empresa_cnpj,
            perPage: 500,
          });

      if (response.success && Array.isArray(response.data)) {
        setServiceList(response.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingsInputs((current) => ({
        ...current,
        serviceList: false,
      }));
    }
  }, [
    queryParams.empresa_cnpj,
    serviceList,
    setLoadingsInputs,
    setServiceList,
  ]);

  const getLeadOriginList = useCallback(async () => {
    try {
      if (listLeadOrigin.length) return;

      setLoadingsInputs((current) => ({
        ...current,
        listLeadOrigin: true,
      }));

      const response = await indexLeadOrigin({ perPage: 500, page: 1 });

      if (response?.success && Array.isArray(response.data)) {
        setListLeadOrigin(response.data);
              }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingsInputs((current) => ({
        ...current,
        listLeadOrigin: false,
      }));
    }
  }, [listLeadOrigin.length, setListLeadOrigin, setLoadingsInputs]);

  const getBillingRuler = useCallback(async () => {
    if (billingRulerFetchedRef.current || billingRulerList.length) return;

    billingRulerFetchedRef.current = true;

    try {
      setLoadingsInputs((current) => ({
        ...current,
        billingRulerList: true,
      }));

      const response = await getBillingRules();

      if (response.success && Array.isArray(response.data)) {
        const activeRules = [];
        let mainRule = null;

        response.data.forEach((rule) => {
          if (rule.active === true) {
            const formatted = {
              value: rule.id,
              label: `${rule.id} - ${rule.name}`,
            };
            activeRules.push(formatted);

            if (rule.default) {
              mainRule = formatted;
            }
          }
        });

        setBillingRulerList(activeRules);

        const defaultRule = mainRule || activeRules[0] || null;
        setSingleBillingRuler(defaultRule);
        setRecurrentBillingRuler(defaultRule);
      } else {
        notify("Não foi possível obter as regras de cobrança.");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingsInputs((current) => ({
        ...current,
        billingRulerList: false,
      }));
    }
  }, [
    billingRulerList.length,
    setBillingRulerList,
    setLoadingsInputs,
    setSingleBillingRuler,
    setRecurrentBillingRuler,
  ]);

  const getSaleTypeList = useCallback(async () => {
    try {
      if (listSaleType.length) return;

      setLoadingsInputs((current) => ({
        ...current,
        listSaleType: true,
      }));

      const response = await indexSaleType({ perPage: 500, page: 1 });

      if (response?.success && Array.isArray(response.data)) {
        setListSaleType(response.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingsInputs((current) => ({
        ...current,
        listSaleType: false,
      }));
    }
  }, [listSaleType.length, setListSaleType, setLoadingsInputs]);

  const refreshLeadOriginList = useCallback(async () => {
    const response = await indexLeadOrigin({ perPage: 500, page: 1 });
    const items =
      response?.success && Array.isArray(response.data) ? response.data : [];
    setListLeadOrigin(items);
    return items;
  }, [setListLeadOrigin]);

  const refreshSaleTypeList = useCallback(async () => {
    const response = await indexSaleType({ perPage: 500, page: 1 });
    const items =
      response?.success && Array.isArray(response.data) ? response.data : [];
    setListSaleType(items);
    return items;
  }, [setListSaleType]);

  const handleLeadOriginSaved = useCallback(
    async (savedItem) => {
      const items = await refreshLeadOriginList();
      const selected =
        items.find((item) => item.id === savedItem.value) ||
        items.find((item) => item.descricao === savedItem.descricao) ||
        null;
      setLeadOrigin(selected);
    },
    [refreshLeadOriginList, setLeadOrigin]
  );

  const handleSaleTypeSaved = useCallback(
    async (savedItem) => {
      const items = await refreshSaleTypeList();
      const selected =
        items.find((item) => item.id === savedItem.value) ||
        items.find((item) => item.descricao === savedItem.descricao) ||
        null;
      setSaleType(selected);
    },
    [refreshSaleTypeList, setSaleType]
  );


  const handleDeleteProposal = async (value) => {
    try {
      if (!value.id)
        return notify("Não foi possível obter o identificador desta proposta.");

      Swal.fire({
        icon: "question",
        text: "Tem certeza que deseja remover esta proposta?",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sim",
        showConfirmButton: true,
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          setLoading(true);
          const resp = await deleteClienteProposta({
            empresa_cnpj: queryParams.empresa_cnpj,
            id: value.id,
          });

          if (resp.success) {
            notify("Proposta removida com sucesso.", true, "success");

            setCustomerProposals((current) =>
              current.filter((i) => i.id !== value.id)
            );
          } else notify("Não foi possível remover a proposta.");

          setLoading(false);
        }
      });

      return;
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    returnCompetencyAndVigency,
    handleScheduling,
    handleSubmit,
    handleClearContext,
    handleDeleteProposal,

    getPaymentWay,
    getReadjustment,
    getPaymentType,
    getContractType,
    getBank,
    getService,
    getLeadOriginList,
    getSaleTypeList,
    handleLeadOriginSaved,
    handleSaleTypeSaved,
    storeLeadOrigin,
    updateLeadOrigin,
    storeSaleType,
    updateSaleType,
    getBillingRuler,
  };
};

export default useTriagemContratoController;
